import React from "react";

type BlurryEffectProps = React.HTMLAttributes<SVGElement>;

function BlurryEffect({ ...props }: Readonly<BlurryEffectProps>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 640"
      preserveAspectRatio="xMidYMin slice"
      className="w-full h-full fill-current"
      {...props}
    >
      <g clipPath="url(#a)" filter="url(#b)">
        <path className="fill-violet-500" d="M988-64h1120V36H988z" />
        <path className="fill-cyan-500" d="M512-46h780V64H512z" />
        <path className="fill-green-400" d="M-200-64h780V46h-780z" />
        <path className="fill-orange-500" d="M816.5-56h400V4h-400z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h1920v440H0z" />
        </clipPath>
        <filter
          id="b"
          width={2708}
          height={528}
          x={-400}
          y={-264}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_614_17172"
            stdDeviation={100}
          />
        </filter>
      </defs>
    </svg>
  );
}

export { BlurryEffect, type BlurryEffectProps };
